export default __webpack_public_path__ + "static/media/225.0c8248e1.jpg";